
import React from 'react';
import { Button } from "@/components/ui/button";
import { InfoIcon } from 'lucide-react';

interface RecommendationCardProps {
  title: string;
  category: string;
  annualSaving: number;
  oneTimeCost: number;
  icon: React.ReactNode;
  onBuyClick?: () => void;
}

const RecommendationCard = ({ 
  title, 
  category, 
  annualSaving, 
  oneTimeCost, 
  icon,
  onBuyClick 
}: RecommendationCardProps) => {
  return (
    <div className="bg-white shadow-lg rounded-xl p-6 w-full h-full min-h-[250px] flex flex-col justify-between">
      <div>
        <div className="flex justify-between items-center">
          <h3 className="text-xl font-semibold text-[#1F2937] line-clamp-2">{title}</h3>
          <div className="text-[#059669] flex-shrink-0 ml-4">
            {icon}
          </div>
        </div>

        <div className="text-sm text-[#6B7280]">{category}</div>

        <div className="space-y-3 mt-4">
          <div className="flex justify-between items-center">
            <span className="text-[#1F2937] text-base">Your Annual Saving</span>
            <span className="text-[#059669] font-semibold text-lg ml-2">£{annualSaving}</span>
          </div>
          <div className="flex justify-between items-center">
            <span className="text-[#1F2937] text-base">One-time Cost</span>
            <span className="text-[#1F2937] font-semibold text-lg ml-2">£{oneTimeCost}</span>
          </div>
        </div>
      </div>

      <div className="flex justify-center mt-6">
        <Button 
          className="w-full max-w-[240px] h-[36px] bg-[#059669] hover:bg-[#047857] text-white"
          onClick={onBuyClick}
        >
          Get Now
        </Button>
      </div>
    </div>
  );
};

export default RecommendationCard;
